export enum EEdgeEditTab {
  STYLE = 'style',
  DESCRIPTION = 'description',
  LINK = 'link',
  VLAN = 'vlan',
  MONITORING = 'monitoring',
  CABLE_TYPE = 'cable-type',
}

export interface IEdgeExtraData {
  // Style
  edgeType?: EEdgeType;
  // VLAN
  vlanIds?: number[];
  untaggedVlan?: string;
  allowIncomingPackets?: EAllowIncomingPackets;
  // Description
  useCustomDescription?: boolean;
  customDescription?: string;
  // Link
  enableLink?: boolean;
  autoNegotiation?: boolean;
  linkSpeed?: ELinkSpeed;
  linkDuplex?: ELinkDuplex;
  linkMdi?: ELinkMdi;
  // Monitoring
  enableMonitoring?: boolean;
  // Cable (single object per connection)
  cableType?: {
    switchConnector: ECableType;
    deviceConnector: ECableType;
    length: number;
  };
}

export enum ECableType {
  X = 'X',
  D = 'D',
  RJ45 = 'RJ45',
}

export enum EEdgeType {
  BEZIER = 'bezier',
  STRAIGHT = 'straight',
  SMOOTHSTEP = 'smoothstep',
}

export enum EAllowIncomingPackets {
  AUTO = 'auto',
  ALLOW_TAGGED = 'allow_tagged',
  ALLOW_UNTAGGED = 'allow_untagged',
  ALLOW_TAGGED_AND_UNTAGGED = 'allow_tagged_and_untagged',
}

export enum EUntaggedVlan {
  AUTO = 'auto',
  NONE = 'none',
}

export enum ELinkSpeed {
  AUTO = 'auto',
  TEN_MBPS = '10',
  HUNDRED_MBPS = '100',
}

export enum ELinkDuplex {
  AUTO = 'auto',
  FULL = 'full',
  HALF = 'half',
}

export enum ELinkMdi {
  AUTO = 'auto',
  MDI = 'mdi',
  MDI_PLUS = 'mdix',
}

export const CABLE_TYPE_LABELS: Record<ECableType, string> = {
  [ECableType.X]: 'M12 X-coded',
  [ECableType.D]: 'M12 D-coded',
  [ECableType.RJ45]: 'RJ45',
};
